import { Icon, IconButton, Tooltip } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import { isNil } from 'lodash'

const SIZE = {
    LARGE: 'large',
    MEDIUM: 'medium',
    SMALL: 'small',
    TINY: 'tiny',
}

const sizeAction = {
    [SIZE.LARGE]: '32px',
    [SIZE.MEDIUM]: '28px',
    [SIZE.SMALL]: '24px',
    [SIZE.TINY]: '20px',
}

const Action = ({
    icon,
    onClick,
    tooltip,
    color = '#161832',
    'data-cy': dataCy,
    size = SIZE.LARGE,
}) => {
    const button = (
        <IconButton
            sx={{ fontSize: sizeAction[size] ?? '32px' }}
            onClick={onClick}
            data-cy={dataCy}
        >
            <Icon fontSize='inherit' sx={{ color }}>{icon}</Icon>
        </IconButton>
    )
    if (isNil(tooltip)) return button
    return (
        <Tooltip title={tooltip}>
            {button}
        </Tooltip>
    )
}

Action.propTypes = {
    icon: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    tooltip: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
    color: PropTypes.string,
    size: PropTypes.oneOf([SIZE.LARGE, SIZE.MEDIUM, SIZE.SMALL, SIZE.TINY]),
    'data-cy': PropTypes.string,
}

export default Action